module.exports = __webpack_public_path__ + "static/media/sort-shapes-down.0a72857e.svg";